import {Component} from '@angular/core';

import {OlMapService} from './services/ol-map.service';

@Component({
  selector: 'app-ol-map',
  templateUrl: './ol-map.component.html',
  styleUrls: ['./ol-map.component.scss']
})
export class OlMapComponent {

  constructor(private olMapService: OlMapService) {

  }

  toggleMode(checked: boolean): void {
    this.olMapService.toggle3D(checked);
  }

}
